import React from 'react';
import { useTheme } from '../../theme';
import onyxMark from '../../assets/gv-header-v-onyx.png';
import greenMark from '../../assets/gv-header-v-venom.png';

export const AccountBrandMark = () => {
  const { theme } = useTheme();
  return <img src={theme === 'venom' ? greenMark : onyxMark} alt="" aria-hidden="true" data-testid="settings-gvrewards-header-mark" />;
};